import { Paper, Popper, PopperPlacementType } from '@mui/material';
import React, { useRef } from 'react';

import { MuiSxProps } from '../types';

import { ClickAwayAndKeydownListener } from './ClickAwayAndKeydownListener';
import { SUBMENU_BOX_SHADOW } from './styleConstants';
interface IVirtualElement {
  getBoundingClientRect: () => DOMRect;
  contextElement?: Element;
}

interface IPopperSubmenuContainerProps {
  anchorEl: HTMLElement | IVirtualElement | (() => HTMLElement) | (() => IVirtualElement) | null;
  dataTest: string;
  open: boolean;
  children: React.ReactNode;
  disablePortal?: boolean;
  placement?: PopperPlacementType;
  styleOverrides?: MuiSxProps;
  positionOffset?: {
    x?: number;
    y?: number;
  };
  disableAutoFocusTrigger?: boolean;
  keydownCallbacks?(e: KeyboardEvent, clickHappenedInside: boolean): void;
  handleClose(e?: MouseEvent | TouchEvent): void;
}

export const PopperSubmenuContainer: React.FC<IPopperSubmenuContainerProps> = ({
  anchorEl,
  open,
  dataTest,
  children,
  disablePortal,
  placement,
  styleOverrides,
  positionOffset,
  disableAutoFocusTrigger,
  keydownCallbacks,
  handleClose
}) => {
  const containerRef = useRef(null);

  return (
    <Popper
      placement={placement}
      anchorEl={anchorEl}
      disablePortal={disablePortal}
      open={open}
      sx={{ zIndex: 999 }}
      popperOptions={{
        modifiers: [{ name: 'offset', options: { offset: [positionOffset?.x || 0, positionOffset?.y || 0] } }]
      }}
    >
      <ClickAwayAndKeydownListener
        handleTrigger={handleClose}
        triggerKeys={['Escape']}
        containerRef={containerRef}
        keydownCallbacks={keydownCallbacks}
        disableAutoFocusTrigger={disableAutoFocusTrigger}
      >
        <Paper
          sx={{
            boxShadow: SUBMENU_BOX_SHADOW,
            backgroundColor: 'background.paper',
            borderRadius: 1,
            ...styleOverrides
          }}
          ref={containerRef}
          data-test={dataTest}
        >
          {children}
        </Paper>
      </ClickAwayAndKeydownListener>
    </Popper>
  );
};
